import { Button as e } from "./Button.js";
import t from "./ButtonIcon.module.js";
import { isValidElement as n } from "react";
import { jsx as r } from "react/jsx-runtime";
//#region lib/components/Button/ButtonIcon.tsx
function i({ icon: n, borderRadius: i, ...o }) {
	let s = a(n, i, o.shape), c = [t["button-icon"], s];
	return /* @__PURE__ */ r(e, {
		className: c.join(" "),
		iconStart: n,
		...o
	});
}
function a(e, n, r) {
	if (n) return t[`border-radius-${n}`];
	if (r === "pill") return "";
	let i = o(e);
	return i && i >= 24 ? t["border-radius-12"] : t["border-radius-8"];
}
function o(e) {
	if (n(e) && typeof e.props == "object" && e.props !== null) return e.props.size;
}
//#endregion
export { i as ButtonIcon };
